import Header from '../components/Header';
import Footer from '../components/Footer';
import HamburgerMenu from '../components/HamburgerMenu';
import Card from '../components/Card';
import { projects } from '../data/projects';
import '../styles/Projects.css';
import { useApp } from '../context/AppContext';

const Projects = () =>{
    const {menuActive, toggleMenu} = useApp();

    return (
        <div>
            <Header setOpenMenu={toggleMenu}></Header>
            <main className='projects'>
                <h2>Proyectos</h2>
                <div className='projects-container'>
                    {projects.map(
                            (project) => (
                                <Card key={project.id} {...project}/>
                            )
                        )
                    }
                </div>
            </main>
            <Footer/>
            <HamburgerMenu isOpenMenu={menuActive} setOpenMenu={toggleMenu}></HamburgerMenu>
        </div>
    );

}

export default Projects;